import type { EnrichedLead } from "./types";

export function extractLeadId(leadCardLink: string): string | null {
  try {
    const url = new URL(leadCardLink);
    return url.searchParams.get("q");
  } catch {
    return null;
  }
}

export function getLeadDisplayName(lead: EnrichedLead): string {
  return (
    (lead.organizationName as string) ||
    (lead.company as string) ||
    "Unidentified lead"
  );
}

export function getLastActivityTimestamp(lead: EnrichedLead): number {
  if (lead.eventUnixTimestamp) return Number(lead.eventUnixTimestamp);
  if (lead.eventEsTimestamp) return Number(lead.eventEsTimestamp);
  return 0;
}

export function formatUnixTimestamp(unixTimestamp: string): string {
  const date = new Date(parseInt(unixTimestamp, 10));
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

export function formatUnixTime(unixTimestamp: string): string {
  const date = new Date(parseInt(unixTimestamp, 10));
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

export function getLeadVisits(lead: EnrichedLead): string | number {
  return lead["total sessions"] ?? lead.totalSessions ?? "-";
}

export function getLeadEvents(lead: EnrichedLead): string | number {
  return lead["total pages viewed"] ?? lead.totalPagesViewed ?? "-";
}
